import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=d3d96114&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=d3d96114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d96114",
  null
  
)

/* custom blocks */
import block0 from "./contact.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiTagline: require('/app/components/ui/tagline.vue').default,UiTransition: require('/app/components/ui/transition.vue').default,UiSocials: require('/app/components/ui/socials.vue').default})
